import axios from "axios";
import config from "../Config.json";

const updatePassword = async (data) => {
    try {       
        const response = await axios.post(`${config.API_URL}/app/updatePassword`, data)
        return response
    } catch (error) {
        return error
    }
}

export default updatePassword;